var exports = {
  "hide-curtain": "x24da60e8--159601--hide-curtain",
  "show-curtain": "x24da60e8--159601--show-curtain",
  "root": "x24da60e8--159601--root",
  "full-screen": "x24da60e8--159601--full-screen",
  "curtain": "x24da60e8--159601--curtain",
  "open": "x24da60e8--159601--open",
  "closed": "x24da60e8--159601--closed",
  "desktop": "x24da60e8--159601--desktop",
  "window": "x24da60e8--159601--window",
  "close-button": "x24da60e8--159601--close-button",
  "hide-overlay": "x24da60e8--159601--hide-overlay",
  "show-overlay": "x24da60e8--159601--show-overlay",
  "dialog-overlay": "x24da60e8--159601--dialog-overlay",
  "header": "x24da60e8--159601--header",
  "empty-header": "x24da60e8--159601--empty-header",
  "content": "x24da60e8--159601--content",
  "header-content": "x24da60e8--159601--header-content",
  "with-title": "x24da60e8--159601--with-title",
};

module.exports = exports;
